import {
  isGuaranteedJevMode,
  type GuaranteedServiceSkuEntry,
} from '@nadoutong/contracts';
import type { LegSkuArming } from './legModel.ts';
import { skuChainMode, skuProbeMode } from './modes.ts';

/** A SKU with no guaranteed-service row: every mechanism is off. */
export const LEG_SKU_ALL_OFF: LegSkuArming = {
  probesOn: false,
  probeAct: false,
  armed: false,
  tripFailedRounds: null,
  recoverOkRounds: null,
};

export function legSkuArming(row: GuaranteedServiceSkuEntry): LegSkuArming {
  const probe = skuProbeMode(row);
  const chain = skuChainMode(row);
  const jev = isGuaranteedJevMode(row.jev_judge) ? row.jev_judge : 'off';
  return {
    probesOn: probe !== 'off',
    probeAct: probe === 'act',
    armed: probe === 'act' || chain === 'act' || jev === 'act',
    tripFailedRounds: row.probe_trip_failed_rounds,
    recoverOkRounds: row.probe_recover_ok_rounds,
  };
}

export function legSkuArmingIndex(
  rows: readonly GuaranteedServiceSkuEntry[],
): ReadonlyMap<string, LegSkuArming> {
  return new Map(rows.map((row) => [row.sku_id, legSkuArming(row)]));
}
